export default __webpack_public_path__ + "static/media/2t.d9d796f1.jpg";